export interface TextStyles {
  textStyleBigParagraph?: string
  textStyleBigParagraphBold?: string
  textStyleMedParagraph?: string
  textStyleMedParagraphBold?: string
  textStyleSmallParagraph?: string
  textStyleH1?: string
  textStyleH2?: string
  textStyleH3?: string
  textStyleTagLine?: string
  textStyleH4?: string
  textStyleH5?: string
  textStyleH6?: string
  textStyleSiteTitle?: string
}

const textStyles: TextStyles = {
  // textStyleBigParagraph: `
  //   font-size:20px;
  //   font-family:"Open Sans", Arial, Helvetica, sans-serif;
  //   font-weight:normal;
  //   font-style:normal;
  //   line-height:30px;
  //   text-decoration:none;
  //   `,

  // textStyleBigParagraph: `
  // // inject fontfam
  //   ${config.fonts.header}

  //   // sensible defaults here
  //   font-size:20px;
  //   font-family:"Open Sans", Arial, Helvetica, sans-serif;
  //   font-weight:normal;
  //   font-style:normal;
  //   line-height:30px;
  //   text-decoration:none;

  //   // inject overrides
  //   ${config.fonts.styles.bigParagraph}
  //   `,

  textStyleSiteTitle: `
    font-size:24px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleBigParagraph: `
    font-size:20px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:normal;
    font-style:normal;
    line-height:30px;
    text-decoration:none;
 `,
  textStyleBigParagraphBold: `
    font-size:20px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:bolder;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleMedParagraph: `
    font-size:16px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:normal;
    font-style:normal;
    line-height:23px;
    text-decoration:none;
 `,
  textStyleMedParagraphBold: `
    font-size:16px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:bolder;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleSmallParagraph: `
    font-size:14px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:normal;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleH1: `
    font-size:42px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    line-height:56px;
    text-decoration:none;
 `,
  textStyleH2: `
    font-size:36px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    line-height:50px;
    text-decoration:none;
 `,
  textStyleH3: `
    font-size:28px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleTagLine: `
    font-size:24px;
    font-family:"Open Sans", Arial, Helvetica, sans-serif;
    font-weight:bolder;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleH4: `
    font-size:24px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    text-decoration:none;
 `,
  textStyleH5: `
    font-size:20px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    line-height:27px;
    text-decoration:none;
 `,
  textStyleH6: `
    font-size:16px;
    font-family:"Overpass";
    font-weight:normal;
    font-style:normal;
    line-height:21px;
    text-decoration:none;
 `,
}

export default textStyles
